import SCAPromotionGrid from '../components/SCAPromotionGrid';
import { PostProvider, SCAProvider } from '../store';

export default function SCAPromotionGridLayout() {
  return <PostProvider>
    <SCAProvider>
      <SCAPromotionGrid />
    </SCAProvider>
  </PostProvider>;
}
